import * as tslib_1 from "tslib";
import { Component, Prop, Watch } from 'vue-property-decorator';
import { ComponentBase } from './ComponentBase';
import ImageList from './ImageList.vue';
import SparkMD5 from 'spark-md5';
import Compressor from 'compressorjs';
import RadioButtonOff from 'vue-ionicons/dist/md-radio-button-off.vue';
import RadioButtonOn from 'vue-ionicons/dist/md-radio-button-on.vue';
import { FileServiceProxy } from '@/lib/service-proxy/FileServiceProxy';
import { FileDescriptionWithMd5 } from '@/lib/service-proxy/FileDescriptionWithMd5';
import { HamazonFile } from '@/components/HamazonFile';
import Util from '@/lib/util';
import Gallery from './Gallery.vue';
var ImageUploader = /** @class */ (function (_super) {
    tslib_1.__extends(ImageUploader, _super);
    function ImageUploader() {
        var _this = _super.call(this) || this;
        _this.gallerySrc = '';
        _this.galleryOriginFlag = false;
        _this.galleryShow = false;
        _this.files = [];
        _this.removeFiles = [];
        _this.fileService = new FileServiceProxy();
        return _this;
    }
    Object.defineProperty(ImageUploader.prototype, "selfReadonly", {
        get: function () {
            return this.readonly;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImageUploader.prototype, "needCamera", {
        /*private get needCamera() {
            const userAgent = navigator.userAgent.toLowerCase();
            const isIOS = userAgent.indexOf('iphone') > 0 || userAgent.indexOf('ipad') > 0;
            return isIOS ? false : 'camera';
        }
    */
        get: function () {
            return false;
        },
        enumerable: true,
        configurable: true
    });
    ImageUploader.prototype.mounted = function () {
        this.loadBeforeFiles(true);
    };
    ImageUploader.prototype.loadBeforeFiles = function (isClear) {
        var _this = this;
        if (isClear) {
            this.files = [];
        }
        if (this.associateId == '0') {
            return;
        }
        this.fileService.all(this.associateType, this.associateId)
            .then(function (result) {
            result.items.forEach(function (value, index) {
                _this.addFileToList(value);
            });
        });
    };
    ImageUploader.prototype.associateIdChange = function (newVal, oldVal) {
        if (newVal === '0') {
            return;
        }
        this.associateId = newVal;
        this.loadBeforeFiles(true);
    };
    ImageUploader.prototype.fileChanged = function (e) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var input, i, orgFile, isContinue, compressor;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        input = e.target;
                        i = 0;
                        _a.label = 1;
                    case 1:
                        if (!(i < input.files.length)) return [3 /*break*/, 4];
                        orgFile = input.files.item(i);
                        return [4 /*yield*/, this.uploadBefore(orgFile)];
                    case 2:
                        isContinue = _a.sent();
                        if (!isContinue) {
                            return [2 /*return*/];
                        }
                        // const reader = new FileReader();
                        // reader.onloadend = (e: any) => {
                        //     console.log(e);
                        //     this.gallerySrc = e.target.result;
                        //     this.galleryShow = true;
                        // };
                        // reader.readAsDataURL(orgFile);
                        // return;
                        abp.ui.setBusy(null, { message: '正在压缩...' });
                        compressor = new Compressor(orgFile, {
                            quality: 0.6,
                            maxWidth: 2048,
                            maxHeight: 2048,
                            success: function (file) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var md5code, fileInfoWithMd5, hamazonFile, fileInfoWithUpload, hamazonFile;
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            abp.ui.clearBusy();
                                            abp.ui.setBusy(null, { message: '正在检查文件是否可以秒传...' });
                                            return [4 /*yield*/, this.calculatFileMd5(file)];
                                        case 1:
                                            md5code = _a.sent();
                                            return [4 /*yield*/, this.checkFileExistsWithMd5(md5code, file.name)];
                                        case 2:
                                            fileInfoWithMd5 = _a.sent();
                                            abp.ui.clearBusy();
                                            abp.ui.setBusy(null, { message: '正在上传...' });
                                            if (!(fileInfoWithMd5 && fileInfoWithMd5.id)) return [3 /*break*/, 3];
                                            hamazonFile = this.addFileToList(fileInfoWithMd5);
                                            this.uploadAfter(file, hamazonFile);
                                            return [3 /*break*/, 5];
                                        case 3: return [4 /*yield*/, this.fileUpload(file)];
                                        case 4:
                                            fileInfoWithUpload = _a.sent();
                                            hamazonFile = this.addFileToList(fileInfoWithUpload);
                                            this.uploadAfter(file, hamazonFile);
                                            _a.label = 5;
                                        case 5:
                                            abp.ui.clearBusy();
                                            return [2 /*return*/];
                                    }
                                });
                            }); },
                            error: function (err) {
                                console.log(err.message);
                            }
                        });
                        _a.label = 3;
                    case 3:
                        i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ImageUploader.prototype.calculatFileMd5 = function (file) {
        return new Promise(function (resolve, reject) {
            var filrPropertyAny = File.prototype;
            var blobSlice = filrPropertyAny.slice ||
                filrPropertyAny.mozSlice ||
                filrPropertyAny.webkitSlice;
            var chunkSize = 2 * 1024 * 1024; // read in chunks of 2MB
            var chunks = Math.ceil(file.size / chunkSize);
            var currentChunk = 0;
            var spark = new SparkMD5.ArrayBuffer();
            var fileReader = new FileReader();
            fileReader.onload = function (ev) {
                spark.append(ev.target.result); // append array buffer
                currentChunk += 1;
                if (currentChunk < chunks) {
                    abp.log.info('正在进行文件分块...');
                    loadNext();
                }
                else {
                    abp.log.info('完成文件分块...');
                    resolve(spark.end());
                }
            };
            fileReader.onerror = function () {
                reject();
            };
            function loadNext() {
                var start = currentChunk * chunkSize;
                var end = start + chunkSize >= file.size ? file
                    .size : start + chunkSize;
                fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
            }
            loadNext();
        });
    };
    ImageUploader.prototype.addFileToList = function (fileInfo) {
        var file = new HamazonFile();
        file.remoteUrl =
            Util.ApiUrl + "file/download/" + fileInfo.fileId;
        file.remoteThumbnailUrl =
            Util.ApiUrl + "file/download/" + fileInfo.fileId + "?/1/w/100/h/100";
        file.fileId = fileInfo.fileId;
        file.id = fileInfo.id;
        file.fileName = fileInfo.fileName;
        file.uploadTime = fileInfo.uploadTime;
        this.files.push(file);
        this.$emit('update:addAttrIds', this.files.map(function (item) { return item.id; }));
        return file;
    };
    ImageUploader.prototype.checkFileExistsWithMd5 = function (md5code, fileName) {
        if (!this.associateType) {
            throw new Error('未指定附件类型！');
        }
        var data = FileDescriptionWithMd5.fromJS({
            associateId: this.associateId,
            associateType: this.associateType,
            description: '',
            md5: md5code,
            fileName: fileName
        });
        return this.fileService.check(data);
    };
    ImageUploader.prototype.fileUpload = function (file) {
        if (!this.associateType) {
            throw new Error('未指定附件类型！');
        }
        return this.fileService.upload(this.associateId, this.associateType, undefined, undefined, { data: file, fileName: file.name });
    };
    ImageUploader.prototype.handlerDelete = function (file) {
        this.files.splice(this.files.findIndex(function (item) { return item.id == file.id; }), 1);
        this.removeFiles.push(file);
        this.$emit('update:delAttrIds', this.removeFiles.map(function (item) { return item
            .id; }));
        this.$emit('update:addAttrIds', this.files.map(function (item) { return item.id; }));
    };
    tslib_1.__decorate([
        Prop({ type: [String], default: function () { return undefined; } })
    ], ImageUploader.prototype, "associateId", void 0);
    tslib_1.__decorate([
        Prop({ type: [String], default: function () { return undefined; } })
    ], ImageUploader.prototype, "associateType", void 0);
    tslib_1.__decorate([
        Prop({ type: [Boolean], default: function () { return true; } })
    ], ImageUploader.prototype, "multiple", void 0);
    tslib_1.__decorate([
        Prop({ type: [Number, Array, String] })
    ], ImageUploader.prototype, "addAttrIds", void 0);
    tslib_1.__decorate([
        Prop({ type: [Number, Array, String] })
    ], ImageUploader.prototype, "delAttrIds", void 0);
    tslib_1.__decorate([
        Prop({ type: [Function], default: function () { return function (file) { return Promise.resolve(true); }; } })
    ], ImageUploader.prototype, "uploadBefore", void 0);
    tslib_1.__decorate([
        Prop({
            type: [Function], default: function () { return function (file, fileInfo) {
            }; }
        })
    ], ImageUploader.prototype, "uploadAfter", void 0);
    tslib_1.__decorate([
        Prop({ type: [Boolean], default: function () { return false; } })
    ], ImageUploader.prototype, "readonly", void 0);
    tslib_1.__decorate([
        Prop({ type: [Number], default: function () { return 1024 * 1024 * 2; } })
    ], ImageUploader.prototype, "maxSize", void 0);
    tslib_1.__decorate([
        Prop({ type: [Number], default: function () { return 5; } })
    ], ImageUploader.prototype, "limitCount", void 0);
    tslib_1.__decorate([
        Prop({ type: [String], default: function () { return '上传图片'; } })
    ], ImageUploader.prototype, "title", void 0);
    tslib_1.__decorate([
        Watch('associateId')
    ], ImageUploader.prototype, "associateIdChange", null);
    ImageUploader = tslib_1.__decorate([
        Component({
            components: {
                ImageList: ImageList,
                Gallery: Gallery,
                RadioButtonOff: RadioButtonOff,
                RadioButtonOn: RadioButtonOn
            }
        })
    ], ImageUploader);
    return ImageUploader;
}(ComponentBase));
export default ImageUploader;
